import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import useMixpanel from "hooks/useMixpanel";
import { CUSTOMER_REFERRAL_EVENTS } from "utils/events";

import questionMark from "../../../assets/images/referral_terms.svg";
import { path } from "../../../utils/const";

const TermsCard = () => {
  const navigate = useNavigate();
  const { track } = useMixpanel();
  const { me } = useSelector((state) => state.app);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 380,
        mx: "auto",
        zIndex: 1,
        marginBottom: 0.8,
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        borderRadius: 4,
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          borderRadius: 3,
          p: 0,
          height: "80px",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "space-between",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontSize: "14px",
              color: "#000000",
            }}
          >
            For more info, click to view{" "}
            <Box
              component="span"
              onClick={() => {
                track(CUSTOMER_REFERRAL_EVENTS.TERMS_CONDITION, {
                  customer_id: me?.customerId,
                  customer_name: me?.fullName,
                  email: me?.email,
                  timestamp: new Date().toISOString(),
                  source: "terms_card",
                });
                navigate(path.customerReferralTermsAndConditions);
              }}
              sx={{
                color: "#00A991",
                fontWeight: "bold",
                cursor: "pointer",
                display: "inline",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              TERMS AND CONDITIONS
            </Box>
            .
          </Typography>
        </Box>

        <Box
          component="img"
          src={questionMark}
          alt="Question mark"
          sx={{
            height: "100%",
            width: "auto",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>


  );
};

export default TermsCard;
